import React from 'react';
import PropTypes from 'prop-types';

import { getStaticMediaURL } from '../app/bootstrap';

export const LoyaltyImage = ({ brandCode, loyaltyImageUrl, logoAlt }) => {
    const staticUrl = getStaticMediaURL(`/images/${brandCode}/${loyaltyImageUrl}`);

    return <img className="loyalty-image" src={staticUrl} alt={logoAlt} />;
};

LoyaltyImage.propTypes = {
    brandCode: PropTypes.string.isRequired,
    loyaltyImageUrl: PropTypes.string.isRequired,
    logoAlt: PropTypes.string.isRequired
};

export default LoyaltyImage;
